import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgStyle, NgTemplateOutlet, NgClass } from '@angular/common';
import { SelectComponent } from '../select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, NgStyle, NgTemplateOutlet, SelectComponent, NgClass, NgxPaginationModule]
})
export class DataTableComponent {

  @Input() caption = '';
  @Input() dataTableId: string = 'dataTable-' + crypto.randomUUID();
  @Input() paginated = false;
  @Input() selectable = false;
  @Input() selectAllEnabled = false;
  @Input() downloadable = false;
  @Input() columns: {key: string, title: string, size: number, class: string, style?: any}[] = [];
  @Input() data: any[] = [];
  @Input() pagination: any = {
    page: 1,
    size: 5,
    total: 0
  };
  @Input() lazy: true;

  @Output() selectAllRows =  new EventEmitter<any>();
  @Output() selectRow =  new EventEmitter<any>();
  @Output() download = new EventEmitter<any>();
  @Output() updateDataTable = new EventEmitter<any>();

  allSelected = false;

  constructor() {
    this.data.forEach(d => d.checked = false);
    this.allSelected = false;
  }

  public isDate(value): boolean {

    return value instanceof Date && !Number.isNaN(value.getTime());
  }

  public downloadSelected(row) {

    this.download.emit(row);
  }

  public getItemsPerPage(): number {
    return Number.parseInt(this.pagination.size);
  }

  public onSelectRow(event, row): void {

      row.checked = (event.target?.checked);
      this.selectRow.emit(row);
      this.isAllItensSelected();
  }

  public toggleSelectAll(event): void {
      this.data.forEach(d => {
          d.checked = event.target.checked;
      });

      this.selectAllRows.emit(event);
  }

  public onPerPageChange(event): void {

    this.pagination.page = 1;
    this.pagination.size  = event;
    if (this.paginated && this.lazy) { this.getApiData(); }
  }

  public onPageChange(page: number): void {

    this.pagination.page = page;
    if (this.paginated && this.lazy) { this.getApiData(); }
  }

  public getApiData() {

    this.updateDataTable.emit();
  }

  public isAllItensSelected() {

    this.allSelected = this.data.every(d => d.checked);
  }
}
